import React, { useEffect, useRef, useState } from "react";
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { DateRangePicker, createStaticRanges, defaultStaticRanges } from 'react-date-range';
import './styles.scss';

interface IPROPS {
  dateRange: any;
  setDateRange: any;
  /** When true (e.g. TotalTickets fullscreen modal): any date span up to today. Default also enforces max 7 days. Future calendar dates are always disabled. */
  unrestricted?: boolean;
}

const CustomDate: React.FC<IPROPS> = ({
  dateRange,
  setDateRange,
  unrestricted = false,
}) => {
  const [errorMessage, setErrorMessage] = useState("");
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const calendarRef = useRef(null);

  const handleSelect = (ranges: any) => {
    const { startDate, endDate } = ranges.selection;

    const today = new Date();

    if (unrestricted) {
      let s = startDate > today ? today : startDate;
      let e = endDate > today ? today : endDate;
      if (s > e) {
        const t = s;
        s = e;
        e = t;
      }
      setDateRange([
        {
          startDate: s,
          endDate: e,
          key: "selection",
        },
      ]);
      return;
    }

    let s = startDate > today ? today : startDate;
    let e = endDate > today ? today : endDate;
    if (s > e) {
      const t = s;
      s = e;
      e = t;
    }
    const diffTime = Math.abs(e - s);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
    if (diffDays > 7) {
      setErrorMessage("Please select a date range of 7 days or less.");
      return;
    }
    setErrorMessage("");
    setDateRange([
      {
        startDate: s,
        endDate: e,
        key: "selection",
      },
    ]);
  };

  const toggleCalendar = () => {
    setIsCalendarOpen(!isCalendarOpen);
  };

  const handleClickOutside = (event: any) => {
    if (calendarRef.current && !calendarRef.current.contains(event.target)) {
      setIsCalendarOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const formatDate = (date: any) => {
    return date.toLocaleDateString("en-GB"); // Format as DD-MM-YYYY
  };

  const staticRanges = createStaticRanges(
    defaultStaticRanges.filter(
      (range) => range.label !== "This Month" && range.label !== "Last Month"
    )
  );

  return (
    <div style={{ position: "relative" }}>
      <div
        style={{ position: "absolute", top: "-9px", left: "5px", background: "white" }}
      >
        <p style={{ margin: "0" }}>
          {unrestricted ? "Custom date range" : "Select date"}
        </p>
      </div>
      <div
        onClick={toggleCalendar}
        style={{
          border: "1px solid #ccc",
          padding: "9px",
          borderRadius: "4px",
          cursor: "pointer",
          overflow: "hidden",
          fontSize: "11px",
        }}
      >
        {`${formatDate(dateRange[0].startDate)} - ${formatDate(dateRange[0].endDate)}`}
      </div>
      {isCalendarOpen && (
        <div
          ref={calendarRef}
          style={{
            position: "absolute",
            zIndex: 1000,
            padding: "5px",
            right: 0 // Added to move the date picker to the left side of the container
          }}
        >
          <DateRangePicker
            editableDateInputs={true}
            onChange={handleSelect}
            moveRangeOnFirstSelection={false}
            ranges={dateRange}
            staticRanges={staticRanges}
            maxDate={new Date()}
          />
        </div>
      )}
      {!unrestricted && errorMessage && (
        <div style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
          {errorMessage}
        </div>
      )}
    </div>
  );
};

export default CustomDate;